import { Component } from "@angular/core";

@Component({
  selector: "no-data",
  templateUrl: "./no-data.component.html",
})
export class NoDataComponent {}
